<pf-listview [items]="festivals" [title]="'festival.title' | translate" [hasSearchSection]="true" [searchPlaceholder]="'Fesztivál neve...'">
    <ng-template #itemTemplate let-festival let-i="index">
        <div class="full-width-hover-row" [class.single-item]="festivals.length === 1" (click)="onSelectFestival(festival)">
            <div class="item-name">
                {{ festival.name }}
            </div>
            <div class="item-name">
                {{ festival.comment }}
            </div>
            <div class="date-display">
                <span class="date">{{ festival.startDate | dateUtil }}</span>
                <mat-icon class="separator-icon">arrow_right_alt</mat-icon>
                <span class="date">{{ festival.endDate | dateUtil }}</span>
            </div>
        </div>
    </ng-template>
</pf-listview>
